/**
 * Application Configuration
 */
export const API_BASE_URL = 'https://api.helpsumapp.com';

export const AUTH_TOKEN_KEY = 'helpsum_token';
export const AUTH_USER_KEY = 'helpsum_admin';

export const ENDPOINTS = {
  LOGIN: '/admin/login',
  CONSUMERS: '/admin/consumers',
  MERCHANTS: '/admin/merchants',
  TRANSACTIONS: '/admin/transactions',
  JOBS: '/admin/jobs',
  DASHBOARD: '/admin/dashboard',
  TOGGLE_ACTIVE: '/admin/active-inactive-user',
  TOGGLE_BLOCK: '/admin/block-unblock-user',
  TOGGLE_VERIFY: '/admin/verify-unverify-user',
  CREATE_USER: '/admin/user-creation-for-admin',
  STATS: {
    USERS: '/admin/stats/users',
    JOBS: '/admin/stats/jobs',
    TRANSACTIONS: '/admin/stats/transactions',
    SERVICES: '/admin/stats/services',
    CATEGORIES: '/admin/stats/categories',
    RATINGS: '/admin/stats/ratings',
    NOTIFICATIONS: '/admin/stats/notifications',
    MESSAGES: '/admin/stats/messages',
  }
};
